import { MDSC_eventMsg } from "./IFrameEvent_types";
import topic from 'dojo/topic';

const regKey = "mdsc_event_regestry";


export class MDSC_IFrameEventsHandler {
    public isActive: boolean = true;
    private allowedOrigin: string;
    private nonce: string;

    constructor(origin: string, iframe_nonce: string) {
        this.nonce = iframe_nonce;
        this.allowedOrigin = this.normalizeURI(origin);

        window.addEventListener('message', this._onMessage_Handle);
        if (typeof (window as any)[regKey] != 'object'){
            (window as any)[regKey] = {};
        }
        let instanceKey: string = this.getGlobalRegestryInstanceKey();
        (window as any)[regKey][instanceKey] = this;
    }

    private getGlobalRegestryInstanceKey(){
        return encodeURIComponent(this.allowedOrigin) + "__" + encodeURIComponent(this.nonce);
    }

    private _onMessage_Handle = (ev: MessageEvent) => {
        if (this.isActive !== true) {
            return;
        }

        // origin check
        if (this.allowedOrigin !== this.normalizeURI(ev.origin)) {
            return;
        }

        // parse data if string
        let data: any;
        if (typeof ev.data === 'string') {
            try {
                data = JSON.parse(ev.data);
            } catch (error) {
                console.warn('MDSC_IFrameEvents: Received invalid JSON message.');
                return; // Not valid JSON
            }
        } else if (typeof ev.data === 'object' && ev.data !== null) {
            data = ev.data;
        } else {
            // Not a string or an object, ignore
            return;
        }

        // Type Guard check
        if (!this._isValidMessage(data)) {
            console.warn('MDSC_IFrameEvents: Received malformed message data.');
            return;
        }

        //  Nonce check
        if (data.nonce !== this.nonce) {
            console.warn('MDSC_IFrameEvents: Received message with invalid nonce.');
            return;
        }

        let dojoEventName = "MDSC_IFRAME_EVENT/" + data.type;
        let payload = data.payload;
        console.info("mdsc iframe event", dojoEventName, payload);
        if (this.isActive === true){ //additionally to combat potential race conditions
            topic.publish(dojoEventName, payload);
        }
    }

    /**
     * Type guard
     */
    private _isValidMessage(data: any): data is MDSC_eventMsg {
        if (typeof data !== 'object' || data === null) {
            return false;
        }

        return (
            typeof data.nonce === 'string' &&
            typeof data.type === 'string' &&
            typeof data.payload === 'object' &&
            data.payload !== null
        );
    }

    private normalizeURI(origin: string): string {
        try {
            const url = new URL(origin);
            return url.origin;
        } catch {
            return origin;
        }
    }

    public destroy() {
        this.isActive = false;
        window.removeEventListener('message', this._onMessage_Handle);
        let instanceKey: string = this.getGlobalRegestryInstanceKey();
        try {
            if ((window as any)[regKey] && (window as any)[regKey][instanceKey]) {
                delete (window as any)[regKey][instanceKey];
            }
        } catch (e) {
            console.warn('MDSC_IFrameEvents: Failed to deregister instance.', e);
        }
    }
}
